import React from "react";

function Loader({ size }) {
  return (
    <div
      className={`${size} border-b-2 mx-auto border-blue-950 rounded-full animate-spin`}
    ></div>
  );
}

export default Loader;
